<template>
  <div class="row">
    <BrandWizardNavigation :brand-id="$route.params.id" />
    <div class="col">
      <b-card>
        <template #header>
          <strong>Alamat</strong>
        </template>
        <div class="text-muted">Halaman Alamat akan tersedia di versi berikutnya.</div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BrandWizardNavigation from '@/components/brand/BrandWizardNavigation.vue'

export default {
  components: { BCard, BrandWizardNavigation },
  mounted() {
    // Preload detail for context (optional)
    this.$store.dispatch('brandV2/getDetail', this.$route.params.id)
  },
}
</script>
